export const DATES_CONSTANTS = {
    defaultErrorMessages: {
        isFuture: "La date est supérieure à la date d'aujourd'hui",
        isPastMinDate: "La date est inférieure à la date minimale possible"
    }
};
